import React from 'react';
import { useFlipOIDC } from '../../components/FlipOIDC';

export default function Location() {
  const { me } = useFlipOIDC();

  return (
    <div className="time-attendance-location">{me.user_profile.location}</div>
  );
}
